import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnlink = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M16.042 13.709L14.792 12.4173C15.3475 12.2645 15.7989 11.9694 16.1462 11.5319C16.4934 11.0944 16.667 10.584 16.667 10.0007C16.667 9.30621 16.4239 8.71593 15.9378 8.22982C15.4517 7.74371 14.8614 7.50065 14.167 7.50065H10.8337V5.83398H14.167C15.3198 5.83398 16.3024 6.24023 17.1149 7.05273C17.9274 7.86523 18.3337 8.84787 18.3337 10.0007C18.3337 10.7923 18.1288 11.5215 17.7191 12.1882C17.3094 12.8548 16.7503 13.3618 16.042 13.709ZM13.2087 10.834L11.542 9.16732H13.3337V10.834H13.2087ZM16.5003 18.834L1.16699 3.50065L2.33366 2.33398L17.667 17.6673L16.5003 18.834ZM9.16699 14.1673H5.83366C4.68088 14.1673 3.69824 13.7611 2.88574 12.9486C2.07324 12.1361 1.66699 11.1534 1.66699 10.0007C1.66699 9.04232 1.95866 8.18815 2.54199 7.43815C3.12533 6.68815 3.87533 6.1951 4.79199 5.95898L6.33366 7.50065H5.83366C5.13921 7.50065 4.54894 7.74371 4.06283 8.22982C3.57671 8.71593 3.33366 9.30621 3.33366 10.0007C3.33366 10.6951 3.57671 11.2854 4.06283 11.7715C4.54894 12.2576 5.13921 12.5007 5.83366 12.5007H9.16699V14.1673ZM6.66699 10.834V9.16732H8.02116L9.66699 10.834H6.66699Z",
		fill: "#005AA0"
	})]
});
const ForwardRef = forwardRef(SvgUnlink);
export { ForwardRef as ReactComponent };
